import React from 'react';
import { Link } from 'react-router-dom';
import { FaChartLine, FaCoins, FaBoxes, FaChartBar, FaWallet, FaChartPie } from 'react-icons/fa';
import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';

function Trading() {
  const { t } = useTranslations();
  
  const tradingCards = [
    {
      title: t('trading.stocks.title'),
      description: t('trading.stocks.description'),
      icon: <FaChartLine className="w-6 h-6 text-[#277B6F]" />,
      
    },
    {
      title: t('trading.currencies.title'),
      description: t('trading.currencies.description'),
      icon: <FaCoins className="w-6 h-6 text-[#277B6F]" />,
      
    },
    {
      title: t('trading.indices.title'),
      description: t('trading.indices.description'),
      icon: <FaChartBar className="w-6 h-6 text-[#277B6F]" />,
      
    },
    {
      title: t('trading.crypto.title'),
      description: t('trading.crypto.description'),
      icon: <FaWallet className="w-6 h-6 text-[#277B6F]" />,
    
    },
    {
      title: t('trading.commodities.title'),
      description: t('trading.commodities.description'),
      icon: <FaBoxes className="w-6 h-6 text-[#277B6F]" />,
      
    },
    {
      title: t('trading.etf.title'),
      description: t('trading.etf.description'),
      icon: <FaChartPie className="w-6 h-6 text-[#277B6F]" />,
      
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {tradingCards.map((card, index) => (
        <div
          key={index}
          className="bg-white rounded-[20px] p-6"
        >
          <div className="flex flex-col h-full">
            <div className="flex items-center mb-4">
              <div className="bg-primary rounded-full w-12 h-12 flex items-center justify-center">
                {card.icon}
              </div>
              <h3 className="text-xl font-semibold ml-3">{card.title}</h3>
            </div>
            <p className="text-gray-600 text-sm mb-6">{card.description}</p>
          </div>
        </div>
      ))}
      <BottomNav />
    </div>
  );
}

export default Trading; 